export default __webpack_public_path__ + "static/media/basic.39d4dad0.svg";